// line/AppLine.jsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import BookLine from './pages/bookLine';
import ReservedLine from './pages/reservedLine';
import MyBookLine from './pages/myBookLine';
import AllBookListLine from './pages/allBookListLine';
import ClosedLine from './pages/closedLine';
import OpenInLine from './pages/OpenInLine';
import LineGuard from './components/LineGuard';

export default function AppLine() {
  return (
    <BrowserRouter basename="/line">
      <Routes>
        {/* 認証トップは必要に応じて Guard 無しでもOK（今回は統一してGuard） */}
        <Route
          path="/book"
          element={
            <LineGuard>
              <BookLine />
            </LineGuard>
          }
        />

        {/* ここがご要望の「LINE/モバイル限定」ページ */}
        <Route
          path="/my"
          element={
            <LineGuard>
              <MyBookLine />
            </LineGuard>
          }
        />
        <Route
          path="/all"
          element={
            <LineGuard>
              <AllBookListLine />
            </LineGuard>
          }
        />
        <Route
          path="/reserved"
          element={
            <LineGuard>
              <ReservedLine />
            </LineGuard>
          }
        />

        {/* 時間外ページ（GuardしてもOK / しなくてもOK） */}
        <Route
          path="/closed"
          element={
            <LineGuard>
              <ClosedLine />
            </LineGuard>
          }
        />

        {/* LINEで開いてください案内（Guard対象外にする） */}
        <Route path="/open-in-line" element={<OpenInLine />} />

        {/* 不正URLは予約トップへ */}
        <Route path="*" element={<Navigate to="/book" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
